/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListComputeTenantsRequest = {
  enabled?: boolean | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type ListComputeTenantsResponse =
  | components.ComputeTenantList
  | components.ComputeErrorEnvelope;

/** @internal */
export const ListComputeTenantsRequest$inboundSchema: z.ZodType<
  ListComputeTenantsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  enabled: z.boolean().optional(),
  cursor: z.string().optional(),
  limit: z.number().int().default(50),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListComputeTenantsRequest$Outbound = {
  enabled?: boolean | undefined;
  cursor?: string | undefined;
  limit: number;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListComputeTenantsRequest$outboundSchema: z.ZodType<
  ListComputeTenantsRequest$Outbound,
  z.ZodTypeDef,
  ListComputeTenantsRequest
> = z.object({
  enabled: z.boolean().optional(),
  cursor: z.string().optional(),
  limit: z.number().int().default(50),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listComputeTenantsRequestToJSON(
  listComputeTenantsRequest: ListComputeTenantsRequest,
): string {
  return JSON.stringify(
    ListComputeTenantsRequest$outboundSchema.parse(listComputeTenantsRequest),
  );
}
export function listComputeTenantsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListComputeTenantsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListComputeTenantsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListComputeTenantsRequest' from JSON`,
  );
}

/** @internal */
export const ListComputeTenantsResponse$inboundSchema: z.ZodType<
  ListComputeTenantsResponse,
  z.ZodTypeDef,
  unknown
> = z.union([
  components.ComputeTenantList$inboundSchema,
  components.ComputeErrorEnvelope$inboundSchema,
]);
/** @internal */
export type ListComputeTenantsResponse$Outbound =
  | components.ComputeTenantList$Outbound
  | components.ComputeErrorEnvelope$Outbound;

/** @internal */
export const ListComputeTenantsResponse$outboundSchema: z.ZodType<
  ListComputeTenantsResponse$Outbound,
  z.ZodTypeDef,
  ListComputeTenantsResponse
> = z.union([
  components.ComputeTenantList$outboundSchema,
  components.ComputeErrorEnvelope$outboundSchema,
]);

export function listComputeTenantsResponseToJSON(
  listComputeTenantsResponse: ListComputeTenantsResponse,
): string {
  return JSON.stringify(
    ListComputeTenantsResponse$outboundSchema.parse(listComputeTenantsResponse),
  );
}
export function listComputeTenantsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListComputeTenantsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListComputeTenantsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListComputeTenantsResponse' from JSON`,
  );
}
